<div class="modal-header mb-ng-modal-header">
  <div class="modal-title mb-ng-modal-title"
       data-cy="mb-ng-modal-title">
    <span *ngIf="modalTitle === 'datasheets'; else userManuals">{{'mbcommon.dataSheets' | mbTranslate}}</span>
    <ng-template #userManuals>{{'pdpProductLine.userManuals' | mbTranslate}}</ng-template>
  </div>
  <button type="button"
          class="mb-ng-modal-close close"
          aria-label="Close"
          data-cy="mb-ng-modal-close"
          (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body mb-ng-modal-body"
     data-cy="mb-ng-modal-body">
  <ng-container *ngIf="modalData">
    <div *ngFor="let data of modalData.entry">
      <div class="cursor-pointer mb-product-line-data-sheet"
           data-cy="mb-product-line-user-manual-sm"
           [innerHTML]="data.value | safeHtml">
      </div>
    </div>
  </ng-container>
</div>


